import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useGetOrganizationQuery } from "../../../../../../autogen/bff-api";
import type { InvitationChange } from "./invitationChanges";
import { OrganizationNameInline } from "../../../../../../common/organizations/OrganizationNameCell";

export const InvitationChangeList = ({ changes }: { changes: InvitationChange[] }) => (
  <Box pt="1" data-testid="invitation-changes">
    {changes.map((change, index) => (
      <InvitationChangeLine key={index} change={change} />
    ))}
  </Box>
);

const InvitationChangeLine = ({ change }: { change: InvitationChange }) => {
  const { t } = useTranslation();
  switch (change.kind) {
    case "companyInvited":
      return (
        <Line name={<OrganizationName id={change.organizationId} />}>
          {t("Invited in this change")}
          {change.recipients.length > 0 ? `: ${change.recipients.join(", ")}` : ""}
        </Line>
      );
    case "peopleAdded":
      return (
        <Line name={<OrganizationName id={change.organizationId} />}>
          {change.recipients.map((recipient) => `+ ${recipient}`).join(", ")}
        </Line>
      );
    case "companyRemoved":
      return <Line name={<OrganizationName id={change.organizationId} />}>{t("No longer invited")}</Line>;
    case "entryInvited":
      return (
        <Line name={change.entryName || t("No organization")}>
          {t("Invited in this change")}: {change.emails.join(", ")}
        </Line>
      );
    case "emailInvitationsWithdrawn":
      return (
        <Text fontSize="sm">{t("{{count}} email invitations withdrawn", { count: change.count })}</Text>
      );
  }
};

const Line = ({ name, children }: { name: React.ReactNode; children: React.ReactNode }) => (
  <Text fontSize="sm">
    <Text as="span" fontWeight="semibold">
      {name}
    </Text>
    {" · "}
    {children}
  </Text>
);

const OrganizationName = ({ id }: { id: string }) => (
  <OrganizationNameInline query={useGetOrganizationQuery({ orgId: id })} />
);
